import type { ReactNode } from 'react'
import { cx } from '@/app/lib/utils'
import styles from './Sticker.module.scss'
import type { StickerProps } from './types'

/**
 * Sticker — etiqueta comercial ("Novedad", "Últimas entradas"…) superpuesta a
 * la imagen de una card. Verde neón con texto negro, esquinas rectas y
 * tipografía Label/XS, como `Tag`. A diferencia de `Tag`, se encoge y trunca
 * con puntos suspensivos si su contenedor es más estrecho que el texto, para
 * no desbordar la imagen en cards pequeñas.
 */
export function Sticker({ children, className }: StickerProps): ReactNode {
  return <span className={cx(styles.sticker, className)}>{children}</span>
}
